import React from 'react';
import { BoldItalicUnderlineToggles, UndoRedo, ListsToggle, InsertTable } from '@mdxeditor/editor';
import TogglePlainTextButton from './TogglePlainTextButton';
import InsertSecretFieldButton from './InsertSecretFieldButton';
import InsertImageButton from './InsertImageButton';
import ToggleVersionsPanelButton from './ToggleVersionsPanelButton';
import BackToLatestButton from './BackToLatestButton';
import SavingStatusIndicator from '@/components/notes/SavingStatusIndicator';
import { useNoteContext } from '@/components/notes/context/NoteContext';
import FullscreenToggle from '@/components/template/FullscreenToggle';
import NoteEncryptionControl from '@/components/notes/NoteEncryptionControl';

interface ToolbarButtonsProps {
  isPlainTextMode?: boolean;
  onTogglePlainText?: () => void;
}

const ToolbarButtons: React.FC<ToolbarButtonsProps> = ({
  isPlainTextMode = false,
  onTogglePlainText
}) => {
  const { isReadOnly } = useNoteContext();

  return (
    <div className="mdx-editor--note-toolbar flex flex-wrap items-center gap-y-1 p-0 w-full">

      {/* Editing buttons — own row on mobile, inline on sm+ */}
      <div className={`flex items-center space-x-1 ${isReadOnly ? 'pointer-events-none opacity-40' : ''}`}>
        {!isPlainTextMode && (
          <>
            <UndoRedo />
            <div className="w-px h-6 bg-gray-300 mx-1" />
            <BoldItalicUnderlineToggles />
            <div className="w-px h-6 bg-gray-300 mx-1" />
            <span className="sm:hidden"><ListsToggle options={['bullet', 'check']} /></span>
            <span className="hidden sm:inline"><ListsToggle /></span>
            <div className="hidden sm:block w-px h-6 bg-gray-300 mx-1" />
            <div className="hidden sm:flex"><InsertTable /></div>
            <div className="w-px h-6 bg-gray-300 mx-1" />
            <InsertImageButton />
            <div className="w-px h-6 bg-gray-300 mx-1" />
            <InsertSecretFieldButton />
          </>
        )}
      </div>

      {/* Meta controls — always together, pushed right on sm+ */}
      <div className="flex items-center gap-1 sm:ml-auto shrink-0">
        {onTogglePlainText && (
          <>
            <TogglePlainTextButton
              isPlainTextMode={isPlainTextMode}
              onToggle={onTogglePlainText}
            />
            <div className="w-px h-4 bg-gray-300 dark:bg-gray-600 mx-1" />
          </>
        )}
        <SavingStatusIndicator />
        <NoteEncryptionControl />
        <BackToLatestButton />
        <div className="hidden sm:block w-px h-4 bg-gray-300 dark:bg-gray-600 mx-1" />
        <div className="hidden sm:flex">
          <ToggleVersionsPanelButton />
        </div>
        <div className="hidden sm:block w-px h-4 bg-gray-300 dark:bg-gray-600 mx-1" />
        <FullscreenToggle />
      </div>

    </div>
  );
};

export default ToolbarButtons;
